export type NavbarLocale = 'en' | 'es'

export const NAVBAR_UI: Record<
  NavbarLocale,
  {
    autoServices: string
    reviews: string
    becomeTechnician: string
    getQuote: string
    getAQuote: string
    needHelp: string
    callUsNow: string
    back: string
    menu: string
    close: string
  }
> = {
  en: {
    autoServices: 'AUTO SERVICES',
    reviews: 'REVIEWS',
    becomeTechnician: 'BECOME A TECHNICIAN',
    getQuote: 'GET QUOTE',
    getAQuote: 'GET A QUOTE',
    needHelp: 'NEED HELP?',
    callUsNow: 'Call us now:',
    back: 'BACK',
    menu: 'Menu',
    close: 'Close',
  },
  es: {
    autoServices: 'SERVICIOS AUTOMOTRICES',
    reviews: 'RESEÑAS',
    becomeTechnician: 'ÚNETE COMO TÉCNICO',
    getQuote: 'COTIZACIÓN',
    getAQuote: 'SOLICITAR COTIZACIÓN',
    needHelp: '¿NECESITAS AYUDA?',
    callUsNow: 'Llámanos:',
    back: 'ATRÁS',
    menu: 'Menú',
    close: 'Cerrar',
  },
}

const GROUP_NAME_ES: Record<string, string> = {
  'Brake Services': 'Mantenimiento de frenos',
  Wipers: 'Limpiaparabrisas',
  'General Maintenance': 'Mantenimiento general',
  'Car Batteries': 'Baterías',
  Filters: 'Filtros',
}

const normalizeLink = (link: string) => link.replace(/\/$/, '') || '/'

const SERVICE_TITLE_ES: Record<string, string> = {
  '/services/brake-pad-replacement': 'Reemplazo de pastillas de freno',
  '/services/brake-rotor-replacement': 'Reemplazo de discos de freno',
  '/services/brake-fluid-flush': 'Limpieza de líquido de frenos',
  '/services/brake-shoe-replacement': 'Reemplazo de zapatas de freno',
  '/services/brake-drum-replacement': 'Reemplazo de tambores de freno',
  '/services/brake-hose-replacement': 'Reemplazo de mangueras de frenos',
  '/services/brake-caliper-replacement': 'Reemplazo de cáliper de freno',
  '/services/windshield-wiper-fluid-fill': 'Llenado de líquido limpiaparabrisas',
  '/services/windshield-wiper-replacement': 'Reemplazo de limpiaparabrisas',
  '/services/wheel-cylinder-replacement': 'Reemplazo de cilindro de rueda',
  '/services/tire-rotation': 'Rotación de llantas',
  '/services/battery-replacement': 'Reemplazo de batería',
  '/services/cabin-air-filter-replacement': 'Reemplazo de filtro de aire acondicionado',
  '/services/engine-air-filter-replacement': 'Reemplazo de filtro de aire del motor',
}

export type ServiceNavItem = {
  linkTitle: string
  link: string
  groupName: string
}

export function getServicesForLocale(items: ServiceNavItem[], locale: NavbarLocale): ServiceNavItem[] {
  if (locale === 'en') return items
  return items.map((item) => {
    const key = normalizeLink(item.link)
    const titleEs = SERVICE_TITLE_ES[key]
    const groupEs = GROUP_NAME_ES[item.groupName]
    return {
      ...item,
      linkTitle: titleEs ?? item.linkTitle,
      groupName: groupEs ?? item.groupName,
    }
  })
}
